<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12 16.4a2 2 0 0 1-1.4-.6 2 2 0 0 1-.6-1.5q0-.8.6-1.4a2 2 0 0 1 1.4-.6q.8 0 1.4.6t.6 1.4-.6 1.5a2 2 0 0 1-1.4.6M7.5 6.7h9l1.6-3.2a1 1 0 0 0 0-1 1 1 0 0 0-.9-.5H6.8a1 1 0 0 0-.9.5 1 1 0 0 0 0 1zM7.8 22h8.4q2.4 0 4.1-1.7a6 6 0 0 0 1.7-4.1 6 6 0 0 0-1.3-3.7l-3.8-4.6H7l-3.8 4.6A6 6 0 0 0 2 16.2q0 2.4 1.7 4.1a6 6 0 0 0 4 1.7"
    />
  </svg>
</template>
